module.exports = __webpack_public_path__ + "static/media/gryphon-atelier.6cf15973.svg";